Vue.component('placeOrderShoppingbasket', {
    data() {
        return {
            root: this.$root,
            modal: {}
        };
    },
    mounted() {

        this.initModal();
    },
    watch: {
    },
    filters: {
        decodeHtml: (html) => {
            var txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value;
        },
    },
    methods: {

        initModal() {
            Vue.nextTick(() => {
                setTimeout(() => {
                    var aModal = document.querySelector("#shopping-data");
                    this.modal = new Modal(aModal);
                }, 500);
            });
        },
        clickTooltip(event) {

            if (event.target.classList.contains('js-modal-close')) {
                // Wait for close animation, otherwise we won't have a background
                setTimeout(() => {
                    this.modal.open();
                }, 400);
            } else {
                this.modal.open();
            }

        },
        submitOrder(e) {
            this.submitForm(e.target);
        },
        submitForm(form) {

            if (form.checkValidity()) {

                if (form.querySelector('.g-recaptcha') !== null) {
                    grecaptcha.reset();
                    grecaptcha.execute();

                    return false;
                } else {

                    var btn = document.getElementById("MainFormSubmitButton");
                    if (btn != null) {
                        btn.disabled = true;
                        if (btn.dataset && btn.dataset.pleasewait) {
                            btn.innerHTML = btn.dataset.pleasewait;
                        }
                    }

                    form.submit();
                    return true;
                }
            }

            return false;
        },

    },
});